export default {
  // Common uses
  'buttonAdd': 'Add',
  'buttonBrowse': 'Browse',
  'buttonCancel': 'Cancel',
  'buttonClear': 'Clear',
  'buttonDelete': 'Delete',
  'buttonDeleteData': 'Delete Data',
  'buttonDeleteWatermark': 'Delete Watermark',
  'buttonRemoveWatermark': 'Remove Watermark From Display',
  'buttonOk': 'OK',
  'buttonSave': 'Save',
  'buttonSaveChanges': 'Save Changes',
  'buttonSubmitting': 'Submitting...',
  'buttonSubmitData': 'Submit Data',
  'confirmRemoveFunc': 'Are you sure to remove this function?',
  'labelCompanyName': 'Octon International Co., Ltd.',
  'labelDataLoading': 'Loading...',
  'labelDbData': 'DB Data',
  'labelHtmlFile': 'HTML File',
  'labelNoDbDataFound': 'No data found in DB',
  'labelRequired': 'Required',
  'labelRequiredFields': 'Required fields',
  'labelSearch': 'Search',
  'labelUrl': 'URL',
  'notifAutoLoggedOut': 'You have been logged out because of inactivity. Please log in again',
  'notifGetTokenError': 'Get token error',
  'placeholderEnter': 'Enter',
  "autoCreateKey":"Failed to automatically insert new key",
  'refresh':'Refresh',
  // Login.vue
  'buttonLogin': 'Login',
  'buttonCreateAccount': 'Create Account',
  'labelCopyrightMessage': 'All Rights Reserved.',
  'labelCreateNewAcccount': 'Create new account',
  'labelDataRetrieveFail': 'Fail to Retrieve data from Server',
  'labelInitializing': 'INITIALIZING...',
  'labelSignInMessage': 'Sign in to your account',
  'labelWelcomeMessage': 'OneConsole',
  'notifAccountAllInvalid': 'Input doesn\'t match any criteria',
  'notifAccountStarnumInvalid': 'Star number is too long, keep it within 10-12 digits',
  'notifLoginError': `Login user 'user_id' failed. Error message: error_message`,
  'notifLoginSuccess': `Login user 'user_id' success`,
  'notifNoRolesAssigned': 'No roles assigned to this account!',
  'placeholderAccount': 'Enter your account',
  'placeholderPxd': 'Enter your password',
  'placeholderSelectCompanyID': 'Select Company ID',
  'notifErrorListDb': 'Failed to call /listdb API',
  'notifErrorLoadLanguage': 'Failed to load language.db',
  'notifErrorLoadSettings': 'Failed to load settings',
  'notifNoCidFound': 'No Company ID found',
  // AppHeaderDropdownNotif.vue
  'labelNewNotification': 'NEW',
  'labelNewNotificationMessage': 'Message',
  'labelConfirmAction': 'Confirm action',
  'labelNoNotifications': 'No notifications',
  'titleAlertNotification': 'Alert Notification',
  'titleInfoNotification': 'Info Notification',
  'titleOtherNotification': 'Other Notification',
  'titleWarningNotification': 'Warning Notification',
  // AppHeaderDropdownAcct.vue
  'confirmLogout': 'Are you sure you want to logout?',
  'labelSettings': 'Settings',
  'labelChangeCompanyId': 'Change Company ID',
  'labelPluginManage': 'Manage Plugin',
  'labelPluginInstall': 'Install Plugin',
  'labelGetAccount': 'Get License',
  'labelChangePxd': 'Change Password',
  'labelLogout': 'Logout',
  // AppSidebar.vue, IStoreSidebarNav.vue
  'labelAddNode': 'Add Node',
  'labelAddPlugin': 'Add Plugin',
  'labelAddRoot': 'Add Root',
  'labelEditNode': 'Edit Node',
  'labelEditPlugin': 'Edit Plugin',
  'labelEditRoot': 'Edit Root',
  'labelRemoveNode': 'Remove Node',
  'labelRemovePlugin': 'Remove Plugin',
  'labelRemoveRoot': 'Remove Root',
  // DefaultLayout.vue
  'notifRemoveNodeError': 'Node removal error!',
  'notifRemoveNodeSuccess': 'Successfully removed node',
  'notifRemovePluginError': 'Plugin removal error!',
  'notifRemovePluginSuccess': 'Successfully removed plugin',
  'notifRemoveRootError': 'Root removal error!',
  'notifRemoveRootSuccess': 'Successfully removed root',
  // FunctionCreator.vue, FunctionEditor.vue
  'buttonAddField': 'Add Field',
  'labelAddOneField': `Please add at least one more field before submitting by clicking 'which_button'`,
  'labelDatabase': 'Database',
  'labelDisabled': 'Disabled',
  'labelDisplayName': 'Display Name',
  'labelModule': 'Module',
  'labelName': 'Name',
  'labelOrder': 'Order',
  'labelParent': 'Path',
  'labelRequiredDisplayName': 'Please enter display name',
  'labelRequiredKey': 'Please enter key for database',
  'labelRequiredModule': 'Please enter module',
  'labelRequiredName': 'Please enter name',
  'labelType': 'Store Type',
  'notifAddNodeSuccess': 'Successfully added new node',
  'notifAddNodeError': 'Failed to add new node',
  'notifHideNodeSuccess': 'Successfully hid the node',
  'optionCustom': 'Custom',
  'optionJson': 'JSON',
  'optionPath': 'Path',
  'optionUrl': 'URL',
  'placeholderDisplayName': 'Enter display name',
  'placeholderField': 'Enter field name',
  'placeholderKey': 'Enter database key',
  'placeholderModule': 'Enter module',
  'placeholderName': 'Enter name',
  'placeholderNameTable': 'Auto-filled by',
  'placeholderOrder': 'Enter order',
  'titleAddNode': 'Add Node',
  'titleEditNode': 'Edit Node',
  'titleTableFieldName': 'Field Name',
  'titleTableFieldType': 'Field Type',
  'titleTableFormat': 'Format',
  'titleTableInRow': 'In Row',
  'titleTableInSearch': 'In Search',
  'titleTableRequired': 'Required',
  'titleTableRemove': 'Remove',
  // CreateNewData.vue, DataViewer.vue, DataEditor.vue
  'confirmDataDelete': 'Are you sure you want to delete your data?',
  'labelDataFound': 'Data found',
  'labelDisplayRows': 'Display Rows',
  'labelEntries': 'entries',
  'labelNoDataFound': `No data found in item_database database`,
  'labelNoDataFoundSearch': `No data found with search_term search keyword in item_database database`,
  'labelSelected': 'Selected',
  'labelOf': 'of',
  'labelRows': 'rows',
  'labelRequiredDate': 'Please set the date',
  'labelRequiredEmail': 'Please enter email',
  'labelRequiredNumber': 'Please enter number',
  'labelRequiredString': 'Please enter your data',
  'labelSearchBy': 'Search',
  'labelShowing': 'Showing',
  'labelTotalData': 'Total data',
  'notifAddDataError': 'Error occurred when adding data',
  'notifAddDataSuccess': 'Successfully added data',
  'notifDataEditError': 'Error saving changes',
  'notifDataEditSuccess': 'Successfully edited data',
  'notifDataDeleteError': 'Error when deleting data',
  'notifDataDeleteSuccess': 'Successfully deleted data',
  'notifEditNodeError': 'Failed to edit node',
  'notifEditNodeSuccess': 'Successfully edited node',
  'notifKeyNotFound': 'Key value not found',
  'notifJsonEditError': 'Failed to parse data, please re-check your edit',
  'notifPropertiesEditError': 'Incorrect properties string format, please re-check your edit',
  'placeholderAddDbKey': 'DB key (autofilled)',
  'titleAddDataModal': 'Add Data',
  'titleEditDataModal': 'Edit Data',
  'tooltipAddDataButton': 'Add Data',
  'tooltipDeleteDataButton': 'Delete Data',
  'tooltipExportDataButton': 'Export Data',
  'tooltipImportDataButton': 'Import Data',
  'tooltipShowCheckboxButton': 'Show Checkbox (select data)',
  // ImportExportModal.vue
  'labelChooseOneOfColumns': 'Choose one of the column(s)',
  'labelExportAs': 'Export As',
  'labelSelectAll': 'Select All',
  'labelChooseColumnsToExport': 'Choose column(s) to export',
  'labelChooseColumnsToImport': 'Choose column(s) to import',
  'notifImportDataSuccess': 'Successfully imported data',
  'notifImportDataError': 'Error importing data',
  'notifInvalidCsv': 'Invalid CSV File',
  'placeholderExportFilename': 'Export Filename',
  'titleExportDataModal': 'Export Data',
  'titleImportDataModal': 'Import Data',
  // AccountCreator.vue, AccountEditor.vue
  'buttonAddUser': 'Add User',
  'buttonEditUser': 'Edit User',
  'buttonRemoveUser': 'Remove User',
  'labelActions': 'Actions',
  'labelActivated': 'Activated',
  'labelActivatedDate': 'Activated Date',
  'labelDateEmpty': 'Please enter the date',
  'labelEmail': 'Email',
  'labelInvalidEmailFmt': 'Email format is invalid, put something like: test@mail.com',
  'labelLanguage': 'Language',
  'labelPxd': 'Password',
  'labelSuspend': 'Suspend',
  'labelUserId': 'User ID',
  'labelUserName': 'User Name',
  'labelUserStatus': 'User Status',
  'labelRole': 'Role',
  'labelCid': 'Company ID',
  'labelDepartment' : "Department",
  'notifAddUserError': 'Error when registering user!',
  'notifAddUserSuccess': 'Successfully registered user',
  'notifDifferentUidEmail': 'User ID and Email are not same!',
  'notifDuplicateData': 'This user ID is already used by another user!',
  'notifModifyUserError': 'Error when editing user data!',
  'notifModifyUserSuccess': 'Successfully edited user data',
  'notifNoWhiteSpcUid': 'No whitespace allowed in user ID!',
  'notifSetActivatedDate': 'Please set \'Activated Date\'!',
  'placeholderEmail': 'Enter email',
  'placeholderUserId': 'Enter your user ID',
  'placeholderUserName': 'Enter your user name',
  'titleAddNewUser': 'Add New User',
  'titleEditUserData': 'Edit User Data',
  'titleShowPxd': 'Click to reveal password',
  'notifCopyPxd': 'Password copied to clipboard!',
  'labelResetPxd': 'Reset Password',
  'notifChooseCid': 'Please choose Company ID',
  'system.accountManager.column.userName': 'User Name',
  'system.accountManager.column.roleNames': 'Roles',
  // ChangePxd.vue
  'labelConfirmNewPxd': 'Confirm the new password',
  'labelCurrentPxd': 'Current password',
  'labelNewPxd': 'New password',
  'placeholderConfirmNewPxd': 'Re-enter your new password',
  'placeholderCurrentPxd': 'Enter your current password',
  'placeholderNewPxd': 'Enter your new password',
  'notifChangePxdError': 'Failed to change password',
  'notifChangePxdSuccess': 'Successfully changed password',
  'notifPxdIncorrect': 'Your password is incorrect!',
  'notifPxdInvalid': 'Your password format is invalid!',
  'notifPxdNotFound': 'Password is not found!',
  'notifPxdRecheck': 'Please re-check your new password!',
  'titleChangePxd': 'Change Password',
  // PluginManager.vue
  'titlePluginManage': 'Manage Plugin',
  'buttonPluginUpdate': 'Update Plugin',
  'buttonPluginInstall': 'Install Plugin',
  'buttonExcludePlugin': 'Exclude',
  'buttonIncludePlugin': 'Include',
  'notifInstallPluginSuccess':'Successfully install Plugin!',
  'notifDataNeed2BeSelected':'Need to select at least 1 Plugin',
  'labelInstallPlugin':'Add new Plugin',
  // GetAccount.vue
  'titleGetAcc':'License',
  'labelSerialNumber':'Serial Number',
  'placeholderSerialNumber':'Please insert your serial number',
  'labelIPAddr':'WAN IP Address',
  'placeholderIPAddr':'Please insert your IP Address',
  'labelMACAddr':'MAC Address',
  'placeholderMACAddr':'Please insert your MAC Address',
  'labelProvisioning':'Provisioning...',
  // RoleCreator.vue, RoleEditor.vue
  'labelRoleName': 'Role Name',
  'labelRoleId': 'Role ID',
  'labelLevelId': 'Role Level',
  'labelFunctionsToAssign': 'Functions To Assign',
  'titleAddRoleModal': 'Define New Role',
  'titleEditRoleModal': 'Edit Role',
  // BackupServerCreator.vue, BackupServerEditor.vue
  'labelCompanyId': 'Company ID',
  'labelCompanyIdExists': 'Company ID Exists',
  'labelEncrypt': 'Encrypt',
  'labelFileUrl': 'File URL',
  'labelImAddress': 'IM Address',
  'labelIndexServers': 'Index Servers',
  'labelPushServicePort': 'Push Service Port',
  'labelPushServicePortal': 'Push Service Portal',
  'labelStarNumberType': 'Star Number Type',
  'labelStarVPort': 'StarV Port',
  'notifAddServerBackupError': 'Error when adding backup server config!',
  'notifAddServerBackupSuccess': 'Successfully added backup server config',
  'notifEditServerBackupError': 'Error when editing backup server config!',
  'notifEditServerBackupSuccess': 'Successfully edited backup server config',
  'notifCheckRequiredData': 'Check for empty required data',
  'notifDuplicateCompanyId': 'Company ID exists! Please use another Company ID',
  'placeholderCompanyId': 'Enter Company ID',
  'placeholderFileUrl': 'Enter File URL',
  'placeholderIMAddr': 'Enter IM Address',
  'placeholderINode': 'Enter iNode Configuration',
  'placeholderIp': 'Enter IP Configuration',
  'placeholderPushServicePort': 'Enter Push Service Port',
  'placeholderPushServicePortal': 'Enter Push Service Portal',
  'placeholderStarNumberType': 'Enter Star Number Type',
  'placeholderStarVPort': 'Enter StarV Port',
  'titleAddBackupServer': 'Define New Backup Server',
  'titleEditBackupServer': 'Edit Backup Server',
  // Page404.vue
  'labelPage404Message': 'The page you are looking for was not found.',
  'titlePage404': 'Sorry',
  // WatermarkSetting.vue
  'confirmWatermarkDelete': 'Are you sure you want to delete this watermark?',
  'labelAddNewWatermark': 'Add New Watermark',
  'labelNoWatermark': 'No watermark',
  'labelSelectWatermark': 'Select Watermark',
  'labelWatermarkFile': 'Watermark File',
  'labelWatermarkName': 'Watermark Name',
  'labelWatermarkPreview': 'Preview',
  'labelWatermarkSetting': 'Watermark Setting',
  'notifAddWatermarkError': 'Failed to add new watermark!',
  'notifAddWatermarkSuccess': 'Successfully added new watermark',
  'notifDeleteWatermarkError': 'Failed to delete \'watermark_name\' watermark!',
  'notifDeleteWatermarkSuccess': 'Successfully deleted \'watermark_name\' watermark',
  'notifSetWatermarkError': 'Failed to set the watermark!',
  'notifSetWatermarkSuccess': 'Successfully set the watermark',
  'placeholderWatermarkFile': 'Upload your watermark file',
  'placeholderWatermarkName': 'Enter your watermark name',
  'placeholderWatermarkSelect': 'Select your watermark',
  'titleWatermarkSetting': 'Watermark Setting',
  // DepartmentManager.vue
  "titleAddDepartmentModal": "Add Department",
  "titleEditDepartmentModal": "Edit Department",
  "system.departmentManager.column.departmentName": "Department Name",
  "system.departmentManager.column.departmentDescription": "Department Description",
  "system.departmentManager.column.users": "Users",
  "system.departmentManager.column.roles": "Roles",
  // LanguageCreator.vue, LanguageEditor.vue
  "labelLangKey": "KEY",
  "labelEnglish": "English",
  "labelTaiwanese": "Chinese (Traditional)",
  "labelChinese": "Chinese (Simplified)",
  "labelJapanese": "Japanese",
  "titleAddLanguageData": "Add Language Data",
  "titleEditLanguageData": "Edit Language Data",
  // PluginInstaller.vue
  "labelPluginName":"Plugin Names",
  'notifAddBinSuccess': 'Successfully upload the bin',
  'notifSetBinError': 'Failed to upload the bin!',
  // ApiManager.vue
  'system.apiManager':'API Manager'
}
